import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/components/WebView/icons/ChatBubbleIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-52c02f92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-body" }
const _hoisted_2 = { class: "left-container" }
const _hoisted_3 = { class: "right-container" }
const _hoisted_4 = { class: "heading" }
const _hoisted_5 = { class: "brief-details" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "details" }
const _hoisted_8 = { class: "description" }
const _hoisted_9 = { class: "date" }
const _hoisted_10 = {
  key: 0,
  class: "footer scheduled"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "scheduled-icon" }, "🕒", -1))
const _hoisted_12 = { class: "scheduled-operations" }
const _hoisted_13 = { class: "scheduled" }
const _hoisted_14 = {
  key: 1,
  class: "footer response-data"
}
const _hoisted_15 = { class: "reactions" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "emojis" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "ChatBubbleIcon"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarOrInitials = _resolveComponent("AvatarOrInitials")!
  const _component_Quote = _resolveComponent("Quote")!
  const _component_TextWithHighlight = _resolveComponent("TextWithHighlight")!
  const _component_NoticeTypeBadge = _resolveComponent("NoticeTypeBadge")!
  const _component_AlertDialog = _resolveComponent("AlertDialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message-container", { seen: _ctx.isSeen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AvatarOrInitials, {
          user: _ctx.userForAvatar,
          size: 68
        }, null, 8, ["user"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.message.sender.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.message.questioncomment)
            ? (_openBlock(), _createBlock(_component_Quote, {
                key: 0,
                class: "quote-comment",
                text: _ctx.message.questioncomment
              }, null, 8, ["text"]))
            : _createCommentVNode("", true),
          _createVNode(_component_TextWithHighlight, {
            class: "subject",
            height: 56,
            text: _ctx.messageText,
            highlights: _ctx.highlights
          }, null, 8, ["text", "highlights"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_NoticeTypeBadge, {
              "notice-type": _ctx.message.type
            }, null, 8, ["notice-type"]),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.time), 1)
          ])
        ])
      ])
    ]),
    (_ctx.mailbox === 'scheduled')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, "Send scheduled for " + _toDisplayString(_ctx.message.friendly_scheduled_at), 1),
            _createElementVNode("div", {
              class: "btn-cancel",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleCancel && _ctx.toggleCancel(...args)), ["stop"]))
            }, "Delete")
          ])
        ]))
      : (_ctx.mailbox === 'sent')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", null, _toDisplayString(_ctx.message.recipient_count) + " recipients", 1),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.emojiCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.emojiCount) + " ", 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.emojiReactions), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.feedbackCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createTextVNode(_toDisplayString(_ctx.feedbackCount) + " ", 1),
                    _hoisted_19
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_AlertDialog, {
      message: `You are about to cancel this notice`,
      show: _ctx.showCancelConfirmation,
      "ok-title": "Continue",
      "on-cancel": _ctx.toggleCancel,
      "on-ok": _ctx.doCancel
    }, null, 8, ["show", "on-cancel", "on-ok"])
  ], 2))
}